import Modal from './Modal';
import css from './Modal.less';
import React from 'react';

import Footer from './ModalFooter';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const General = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    header,
    onOk,
    okText,
    onCancel,
    cancelText,
    children,
    visible,
    ...rest
  } = props;
  const title = <div className={css.modalHeader}>{header}</div>;
  return (
    <Modal
      className={css.themeHeader}
      visible={visible}
      title={title}
      onCancel={onCancel}
      cancelText={getI18n('general.antd.Modal.ModalFooter.cancel')}
      {...rest}>
      <div className={css.contentContainer}> {children}</div>
      <Footer
        onOk={onOk}
        okText={okText}
        cancelText={cancelText}
        onCancel={onCancel}
      />
    </Modal>
  );
};
export default General;
